module.exports = __webpack_public_path__ + "assets/custom-page-icon.f2a43649.svg";